/* HNSTLY — ficha de producto: color/talla, galería y «Hay más» */
(function () {
  function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f)}
  ready(function () {
    var root=document.querySelector('[data-hn-pdp]');
    if(!root)return;
    var imgs=[].slice.call(root.querySelectorAll('[data-ph] img'));
    var ph=root.querySelector('[data-ph]'),dots=root.querySelector('[data-dots]'),thumbs=root.querySelector('[data-thumbs]');
    var prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
    var cBtns=[].slice.call(root.querySelectorAll('[data-colors] button'));
    var sBtns=[].slice.call(root.querySelectorAll('[data-sizes] button'));
    var vJson=root.querySelector('[data-variants]'),pJson=root.querySelector('[data-pos]');
    var variants=vJson?JSON.parse(vJson.textContent):[];
    var pos=pJson?JSON.parse(pJson.textContent):{c:-1,s:-1};
    var idInput=root.querySelector('[data-variant-id]'),priceEl=root.querySelector('[data-price]');
    var buy=root.querySelector('.hn-buy'),buyText=root.querySelector('[data-buy-text]');
    var colorName=root.querySelector('[data-color-name]');
    function pressedIdx(btns){for(var k=0;k<btns.length;k++){if(btns[k].getAttribute('aria-pressed')==='true')return k}return 0}
    var ci=pressedIdx(cBtns),si=pressedIdx(sBtns),i=0;
    function colorKey(){return cBtns[ci]?(cBtns[ci].dataset.color||'').toLowerCase():''}
    function list(){
      var c=colorKey();
      var l=imgs.filter(function(im){var d=im.dataset.color||'';return d===''||d===c});
      var own=l.filter(function(im){return (im.dataset.color||'')===c&&c!==''});
      return (c!==''&&own.length===0)?imgs:l;
    }
    function find(cv,sv){
      return variants.filter(function(v){
        return (pos.c<0||v.o[pos.c]===cv)&&(pos.s<0||v.o[pos.s]===sv);
      })[0];
    }
    function updateVariant(){
      var cv=cBtns[ci]?cBtns[ci].dataset.value:null,sv=sBtns[si]?sBtns[si].dataset.value:null;
      sBtns.forEach(function(b){var v=find(cv,b.dataset.value);b.classList.toggle('na',!v||!v.a)});
      var v=find(cv,sv);
      if(!v)return;
      if(idInput)idInput.value=v.id;
      if(priceEl)priceEl.textContent=v.p;
      if(buy){buy.disabled=!v.a;if(buyText)buyText.textContent=v.a?'Añadir a la bolsa':'Agotado'}
      if(window.history&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u)}
    }
    function render(){
      var l=list();
      if(i>=l.length)i=0;
      imgs.forEach(function(im){var on=l[i]===im;im.classList.toggle('on',on);im.setAttribute('aria-hidden',on?'false':'true')});
      if(dots){dots.innerHTML='';if(l.length>1){l.forEach(function(_,k){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Foto '+(k+1)+' de '+l.length);b.setAttribute('aria-current',String(k===i));b.innerHTML='<i></i>';b.addEventListener('click',function(){i=k;render()});dots.appendChild(b)})}}
      if(thumbs){thumbs.innerHTML='';if(l.length>1){l.forEach(function(im,k){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Ver foto '+(k+1));b.setAttribute('aria-current',String(k===i));var t=document.createElement('img');t.src=im.currentSrc||im.src;t.alt='';b.appendChild(t);b.addEventListener('click',function(){i=k;render()});thumbs.appendChild(b)})}}
      if(prev)prev.hidden=l.length<2;if(next)next.hidden=l.length<2;
      cBtns.forEach(function(b,k){b.setAttribute('aria-pressed',String(k===ci))});
      sBtns.forEach(function(b,k){b.setAttribute('aria-pressed',String(k===si))});
      if(colorName&&cBtns[ci])colorName.textContent=cBtns[ci].dataset.value;
      updateVariant();
    }
    cBtns.forEach(function(b,k){b.addEventListener('click',function(){ci=k;i=0;render()})});
    sBtns.forEach(function(b,k){b.addEventListener('click',function(){si=k;render()})});
    function step(d){var n=list().length;i=(i+d+n)%n;render()}
    if(prev)prev.addEventListener('click',function(){step(-1)});
    if(next)next.addEventListener('click',function(){step(1)});
    var x0=null;
    if(ph){ph.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
      ph.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)step(dx<0?1:-1);x0=null},{passive:true})}
    render();
    var rel=document.querySelector('[data-rel]'),rp=document.querySelector('[data-rel-prev]'),rn=document.querySelector('[data-rel-next]');
    if(rel&&rp&&rn){
      rp.addEventListener('click',function(){rel.scrollBy({left:-rel.clientWidth*0.6,behavior:'smooth'})});
      rn.addEventListener('click',function(){rel.scrollBy({left:rel.clientWidth*0.6,behavior:'smooth'})});
    }
  });
})();
